import { plugin } from '@/common/core';
import { PLUGIN_NAME } from '../const';
import { dayjs } from './dayjs';
import BigNumber from 'bignumber.js';
export function exec(funName, defaultObj, args) {
    var _a;
    try {
        const pluginFun = (_a = plugin(PLUGIN_NAME)) === null || _a === void 0 ? void 0 : _a[funName];
        const thisContext = { dayjs, BigNumber };
        const fun = pluginFun ? pluginFun : defaultObj[funName];
        return fun.apply(thisContext, args);
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
